import javaService from "../../utils/request"

 // 快讯
 export function NewsFlash(data){
  return javaService({
    url: '/front/newsFlash',
    method: 'GET',
    params: data
  })
 }
